import {
  IAvailableApplication,
  IDeployApplicationPayload,
  ICreateWorkloadPatternPayload,
  ICreateWorkloadPatternResponse,
  IEnvironment,
  IEnvironmentPayload,
  IWorkloadPattern,
} from '../../models/AppsAndSolutionsModels';
import { IStoreAction } from '../StoreHelper';

export enum AppsAndSolutionsActionTypes {
  GET_ENVIRONMENTS_START = 'GET_ENVIRONMENTS_START',
  GET_ENVIRONMENTS_SUCCESS = 'GET_ENVIRONMENTS_SUCCESS',
  GET_ENVIRONMENTS_ERROR = 'GET_ENVIRONMENTS_ERROR',
  GET_WORKLOAD_PATTERNS_START = 'GET_WORKLOAD_PATTERNS_START',
  GET_WORKLOAD_PATTERNS_SUCCESS = 'GET_WORKLOAD_PATTERNS_SUCCESS',
  GET_WORKLOAD_PATTERNS_ERROR = 'GET_WORKLOAD_PATTERNS_ERROR',
  GET_AVAILABLE_APPLICATIONS_START = 'GET_AVAILABLE_APPLICATIONS_START',
  GET_AVAILABLE_APPLICATIONS_SUCCESS = 'GET_AVAILABLE_APPLICATIONS_SUCCESS',
  GET_AVAILABLE_APPLICATIONS_ERROR = 'GET_AVAILABLE_APPLICATIONS_ERROR',
  DEPLOY_APPLICATION_START = 'DEPLOY_APPLICATION_START',
  DEPLOY_APPLICATION_SUCCESS = 'DEPLOY_APPLICATION_SUCCESS',
  DEPLOY_APPLICATION_ERROR = 'DEPLOY_APPLICATION_ERROR',
  CREATE_WORKLOAD_PATTERN_START = 'CREATE_WORKLOAD_PATTERN_START',
  CREATE_WORKLOAD_PATTERN_SUCCESS = 'CREATE_WORKLOAD_PATTERN_SUCCESS',
  CREATE_WORKLOAD_PATTERN_ERROR = 'CREATE_WORKLOAD_PATTERN_ERROR',
  APPS_AND_SOLN_HARD_RELOAD = 'APPS_AND_SOLN_HARD_RELOAD',
}

export type AppsAndSolutionsActionPayload =
  | boolean
  | string
  | Error
  | Array<IEnvironment>
  | Array<IWorkloadPattern>
  | Array<IAvailableApplication>
  | IEnvironmentPayload
  | IDeployApplicationPayload
  | ICreateWorkloadPatternPayload
  | ICreateWorkloadPatternResponse;

export type AppsAndSolutionsAction = IStoreAction<
  AppsAndSolutionsActionTypes,
  AppsAndSolutionsActionPayload
>;
export class AppsAndSolutionsActions {
  public static getEnvironmentsStart(data: IEnvironmentPayload): AppsAndSolutionsAction {
    return {
      type: AppsAndSolutionsActionTypes.GET_ENVIRONMENTS_START,
      data,
    };
  }

  public static getEnvironmentsSuccess(data: Array<IEnvironment>): AppsAndSolutionsAction {
    return {
      type: AppsAndSolutionsActionTypes.GET_ENVIRONMENTS_SUCCESS,
      data,
    };
  }

  public static getEnvironmentsError(data: Error): AppsAndSolutionsAction {
    return {
      type: AppsAndSolutionsActionTypes.GET_ENVIRONMENTS_ERROR,
      data,
    };
  }
  public static getWorkloadPatternsStart(data: IEnvironmentPayload): AppsAndSolutionsAction {
    return {
      type: AppsAndSolutionsActionTypes.GET_WORKLOAD_PATTERNS_START,
      data,
    };
  }

  public static getWorkloadPatternsSuccess(data: Array<IWorkloadPattern>): AppsAndSolutionsAction {
    return {
      type: AppsAndSolutionsActionTypes.GET_WORKLOAD_PATTERNS_SUCCESS,
      data,
    };
  }

  public static getWorkloadPatternsError(data: Error): AppsAndSolutionsAction {
    return {
      type: AppsAndSolutionsActionTypes.GET_WORKLOAD_PATTERNS_ERROR,
      data,
    };
  }
  public static getAvailableApplicationsStart(data: IEnvironmentPayload): AppsAndSolutionsAction {
    return {
      type: AppsAndSolutionsActionTypes.GET_AVAILABLE_APPLICATIONS_START,
      data,
    };
  }

  public static getAvailableApplicationsSuccess(
    data: Array<IAvailableApplication>,
  ): AppsAndSolutionsAction {
    return {
      type: AppsAndSolutionsActionTypes.GET_AVAILABLE_APPLICATIONS_SUCCESS,
      data,
    };
  }

  public static getAvailableApplicationsError(data: Error): AppsAndSolutionsAction {
    return {
      type: AppsAndSolutionsActionTypes.GET_AVAILABLE_APPLICATIONS_ERROR,
      data,
    };
  }
  public static deployApplicationStart(data: IDeployApplicationPayload): AppsAndSolutionsAction {
    return {
      type: AppsAndSolutionsActionTypes.DEPLOY_APPLICATION_START,
      data,
    };
  }

  public static deployApplicationSuccess(response: string): AppsAndSolutionsAction {
    return {
      type: AppsAndSolutionsActionTypes.DEPLOY_APPLICATION_SUCCESS,
      data: response,
    };
  }

  public static deployApplicationError(data: Error): AppsAndSolutionsAction {
    return {
      type: AppsAndSolutionsActionTypes.DEPLOY_APPLICATION_ERROR,
      data,
    };
  }
  public static createWorkloadPatternStart(
    data: ICreateWorkloadPatternPayload,
  ): AppsAndSolutionsAction {
    return {
      type: AppsAndSolutionsActionTypes.CREATE_WORKLOAD_PATTERN_START,
      data,
    };
  }

  public static createWorkloadPatternSuccess(
    response: ICreateWorkloadPatternResponse,
  ): AppsAndSolutionsAction {
    return {
      type: AppsAndSolutionsActionTypes.CREATE_WORKLOAD_PATTERN_SUCCESS,
      data: response,
    };
  }

  public static createWorkloadPatternError(data: Error): AppsAndSolutionsAction {
    return {
      type: AppsAndSolutionsActionTypes.CREATE_WORKLOAD_PATTERN_ERROR,
      data,
    };
  }
  public static handleHardReload(): AppsAndSolutionsAction {
    return {
      type: AppsAndSolutionsActionTypes.APPS_AND_SOLN_HARD_RELOAD,
    };
  }
}
